import React from 'react';

/**
 * Error boundary for a single asset card. If the card throws (e.g. bad data),
 * renders a fallback row so the rest of the list still works.
 */
export class CardErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Asset card error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const assetId = this.props.assetId ?? '?';
      return (
        <li className="asset-card asset-card-error-fallback">
          <div className="asset-card-main">
            <span className="asset-card-code">Asset #{assetId}</span>
            <span className="text-muted" style={{ fontSize: '0.875rem' }}>
              Failed to load — check console
            </span>
          </div>
        </li>
      );
    }
    return this.props.children;
  }
}
